import { InputBase, type InputBaseProps } from '@mui/material'
import { forwardRef } from 'react'
import { SPREADSHEET_CELL_INSET } from './SpreadsheetCell'

type SpreadsheetInputProps = Omit<InputBaseProps, 'ref' | 'fullWidth' | 'sx'>

// The input owns the inset rather than the cell, so it coincides with the one the theme gives an
// Autocomplete's input root instead of stacking with it.
export const SpreadsheetInput = forwardRef<HTMLDivElement, SpreadsheetInputProps>((props, ref) => (
  <InputBase
    {...props}
    ref={ref}
    fullWidth
    sx={(theme) => ({ height: '100%', paddingInline: theme.spacing(SPREADSHEET_CELL_INSET) })}
  />
))

SpreadsheetInput.displayName = 'SpreadsheetInput'
